import { ROLES } from "../common/Const";
import { ATTENDANCE_STATUS } from "./lessonAttendanceStatus";
import { cancellationMode } from "../../../LambdaFunctions/shared/lessonCancellationPolicy";

export const wholeLessonCancellationMode = ({ role, systemRoles = [], lesson, lessonDetails = {}, now = Date.now() }) => {
  if (!lesson || !lessonDetails.durationMinutes || !lessonDetails.startTime) return "";
  try {
    return cancellationMode({ auth: { role, systemRoles },
      occurrence: lessonDetails,
      register: lesson.lessonRegister,
      reason: "permission check",
      now });
  } catch (_) { return ""; }
};

export const canCancelWholeLesson = input => Boolean(wholeLessonCancellationMode(input));

export const canEditLessonAttendance = (role, userTeacherId, lessonDetails) => (
  role !== ROLES.TEACHER || (lessonDetails || {}).teacherId === userTeacherId
);

export const canUseLessonCommandRole = role => role === ROLES.ADMIN || role === ROLES.OPERATOR;

export const isFutureLessonDetails = (lessonDetails = {}, now = new Date()) => {
  if (!lessonDetails.date) {
    return false;
  }

  const lessonStart = new Date(`${lessonDetails.date}T${lessonDetails.startTime || "00:00"}`);
  return !Number.isNaN(lessonStart.getTime()) && lessonStart > now;
};

export const getAdministrativeLessonCommandBlockReason = ({
  role,
  lesson,
  lessonDetails,
  now,
}) => {
  if (!canUseLessonCommandRole(role)) {
    return "role";
  }

  if (!lesson) {
    return "missingLesson";
  }

  if (!isFutureLessonDetails(lessonDetails, now)) {
    return "past";
  }

  if ((lessonDetails || {}).attendanceStatus === ATTENDANCE_STATUS.CHECKED) {
    return "checked";
  }

  if ((lessonDetails || {}).lessonStatus === "cancelled") {
    return "cancelled";
  }

  return "";
};

export const canUseAdministrativeLessonCommands = ({
  role,
  lesson,
  lessonDetails,
  now,
}) => !getAdministrativeLessonCommandBlockReason({
  role,
  lesson,
  lessonDetails,
  now,
});

export const canUndoWholeLessonCancellation = ({
  role,
  lesson,
  lessonDetails,
}) => (
  canUseLessonCommandRole(role) &&
  !!(lesson && lesson.lessonRegister) &&
  (lessonDetails || {}).lessonStatus === "cancelled"
);
